module.exports = __webpack_public_path__ + "img/Comic02-2.0ff9f336.png";